import { canonicalWebOrigin, isNativeShell } from '../auth/authRedirect';

const NATIVE_API_BRIDGE_KEY = '__SMFD_NATIVE_API_BRIDGE__';

function nativeApiUrl(value) {
  const raw = String(value || '');
  if (!raw.startsWith('/api/')) return raw;
  return `${canonicalWebOrigin()}${raw}`;
}

export function installNativeApiBridge() {
  if (typeof window === 'undefined' || !isNativeShell()) return false;
  if (window[NATIVE_API_BRIDGE_KEY]) return true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === 'string') {
      return nativeFetch(nativeApiUrl(input), init);
    }
    if (typeof URL !== 'undefined' && input instanceof URL) {
      const rewritten = nativeApiUrl(`${input.pathname}${input.search}${input.hash}`);
      if (rewritten !== `${input.pathname}${input.search}${input.hash}`) {
        return nativeFetch(rewritten, init);
      }
      return nativeFetch(input, init);
    }
    if (typeof Request !== 'undefined' && input instanceof Request) {
      try {
        const parsed = new URL(input.url);
        const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
        const rewritten = nativeApiUrl(path);
        if (rewritten !== path) return nativeFetch(new Request(rewritten, input), init);
      } catch (_) {}
    }
    return nativeFetch(input, init);
  };

  window[NATIVE_API_BRIDGE_KEY] = {
    apiOrigin: canonicalWebOrigin(),
    installedAt: new Date().toISOString(),
  };
  return true;
}

export function nativeApiBridgeInfo() {
  if (typeof window === 'undefined') return null;
  return window[NATIVE_API_BRIDGE_KEY] || null;
}
